module.exports = __webpack_public_path__ + "img/pro_fourteen_7.e32f94ed.jpg";